import React from 'react';
import hipladeTemplate from '../../common/template'; // Importe o hipladeTemplate
import Settings from '../components/Settings'; // Importe o componente Settings que você criou

const SettingsWithTemplate = hipladeTemplate(Settings); // Envolve o componente Settings com o hipladeTemplate

export default SettingsWithTemplate;
